import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreAgentConversationSearchSlice } from './get';

export const coreAgentConversationSearchReducers = combineReducers({
	get: getCoreAgentConversationSearchSlice.asyncReducers
});

export const coreAgentConversationSearchWatchers = combineAllWatchers([
	getCoreAgentConversationSearchSlice.asyncWatchers
]);
